import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import Home from "./Page/Home";
import Detail from "./Page/Detail";
import HowItWorks from "./Page/HowItWorks";
import LayoutPage from "./Page/Layout";
import Layout from "./../src/Manage/Layout";
import ManageHome from "./../src/Manage/Home";
import ManageDetail from "./../src/Manage/Detail";
import ManageApp from "./../src/Manage/Application";
import ManageLiveChat from "./../src/Manage/LiveChat";
import ManageAppDetail from "./../src/Manage/ApplicationDetail";
import ManageQuestions from "./../src/Manage/Questions";
import ManageTopics from "./../src/Manage/Topic";
import ManageCircleUser from "./../src/Manage/CircleUser";
import ManageCircleDetail from "./../src/Manage/CircleUser/detail";
import Profile from "./../src/Manage/Profile";
import AOS from 'aos';
import "aos/dist/aos.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { toast, ToastContainer } from "react-toastify";
import { logout } from "./actions/member";

import "bootstrap/dist/css/bootstrap.min.css";
import OurTeam from "./Page/OurTeam";
import ContactUs from "./Page/ContactUs";

function App(props) {
  useEffect(() => {
    AOS.init({
      duration: 2000,
      disable: 'mobile'
    });
    AOS.refresh();
  }, [])

  const { member = {}, logout } = props;
  const { isUserLoggedIn, role } = member;
  function showToast(type, message) {
    // 0 = warning, 1 = success
    switch (type) {
      case 0:
        toast.warning(message);
        break;
      case 1:
        toast.success(message);
        break;
      default:
        break;
    }
  }

  return (
    <>
      <ToastContainer
        autoClose={2000}
        hideProgressBar={true}
        position={toast.POSITION.TOP_RIGHT}
      />
      <Router>
        <Switch>
          {isUserLoggedIn && (role === "dev" || role === "admin") ? (
            <Route
              exact
              path="/manage/home"
              component={(props) => (
                <Layout
                  {...props}
                  logout={() => {
                    logout();
                  }}
                  member={member}
                  Component={ManageHome}
                  active="2"
                />
              )}
            />
          ) : null}

          {isUserLoggedIn && (role === "dev" || role === "admin") ? (
            <Route
              exact
              path="/manage/applications"
              component={(props) => (
                <Layout
                  {...props}
                  logout={() => {
                    logout();
                  }}
                  member={member}
                  Component={ManageApp}
                  active="3"
                />
              )}
            />
          ) : null}
          {isUserLoggedIn && (role === "dev" || role === "admin") ? (
            <Route
              exact
              path="/manage/applications/add"
              component={(props) => (
                <Layout
                  {...props}
                  logout={() => {
                    logout();
                  }}
                  isBack={true}
                  member={member}
                  Component={ManageAppDetail}
                  active="3"
                />
              )}
            />
          ) : null}
          {isUserLoggedIn && (role === "dev" || role === "admin") ? (
            <Route
              exact
              path="/manage/:id/applications"
              component={(props) => (
                <Layout
                  {...props}
                  logout={() => {
                    logout();
                  }}
                  isBack={true}
                  member={member}
                  Component={ManageAppDetail}
                  active="3"
                />
              )}
            />
          ) : null}
          {isUserLoggedIn && (role === "dev" || role === "admin") ? (
            <Route
              exact
              path="/manage/live-chat"
              component={(props) => (
                <Layout
                  {...props}
                  showToast={(type, message) => showToast(type, message)}
                  logout={() => {
                    logout();
                  }}
                  member={member}
                  Component={ManageLiveChat}
                  active="1"
                />
              )}
            />
          ) : null}
          {isUserLoggedIn && (role === "dev" || role === "admin") ? (
            <Route
              exact
              path="/manage/:id/detail"
              component={(props) => (
                <Layout
                  {...props}
                  showToast={(type, message) => showToast(type, message)}
                  logout={() => {
                    logout();
                  }}
                  member={member}
                  Component={ManageDetail}
                  active="4"
                />
              )}
            />
          ) : null}

          {isUserLoggedIn ? (
            <Route
              exact
              path="/manage/questions"
              component={(props) => (
                <Layout
                  {...props}
                  logout={() => {
                    logout();
                  }}
                  member={member}
                  Component={ManageQuestions}
                  active="5"
                />
              )}
            />
          ) : null}

          {isUserLoggedIn ? (
            <Route
              exact
              path="/manage/profile"
              component={(props) => (
                <Layout
                  {...props}
                  logout={() => {
                    logout();
                  }}
                  member={member}
                  Component={Profile}
                  active="6"
                />
              )}
            />
          ) : null}
          {isUserLoggedIn ? (
            <Route
              exact
              path="/manage/circle-user"
              component={(props) => (
                <Layout
                  {...props}
                  logout={() => {
                    logout();
                  }}
                  member={member}
                  Component={ManageCircleUser}
                  active="7"
                />
              )}
            />
          ) : null}

          {isUserLoggedIn ? (
            <Route
              exact
              path="/manage/circle-user/:id"
              component={(props) => (
                <Layout
                  {...props}
                  logout={() => {
                    logout();
                  }}
                  member={member}
                  Component={ManageCircleDetail}
                  isBack={true}
                  active="7"
                />
              )}
            />
          ) : null}

          {isUserLoggedIn && (role === "dev" || role === "admin") ? (
            <Route
              exact
              path="/manage/topics"
              component={(props) => (
                <Layout
                  {...props}
                  logout={() => {
                    logout();
                  }}
                  member={member}
                  Component={ManageTopics}
                  active="8"
                />
              )}
            />
          ) : null}
          <Route
            path="/:id/detail"
            component={(props) => <LayoutPage {...props} Component={Detail} />}
          />
          <Route
            path="/how-it-works"
            component={(props) => (
              <LayoutPage {...props} Component={HowItWorks} />
            )}
          />
          <Route
            path="/our-team"
            component={(props) => <LayoutPage {...props} Component={OurTeam} />}
          />
          <Route
            path="/contact-us"
            component={(props) => (
              <LayoutPage {...props} Component={ContactUs} />
            )}
          />
          <Route
            path="/"
            component={(props) => <LayoutPage {...props} Component={Home} />}
          />
        </Switch>
      </Router>
    </>
  );
}
const mapStateToProps = (state) => ({
  member: state.member || {},
});

const mapDispatchToProps = (dispatch) => {
  return {
    logout: (data) => logout(data),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
